var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 98,
    r: 98,
    fill: "#EB742E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4161 37.9041C89.8402 40.2747 89.9504 39.3926 89.9504 69.2188C89.9504 93.7524 90.0056 95.5718 90.9979 97.336C93.8648 102.684 102.024 102.684 104.891 97.336C105.883 95.5718 105.939 93.7524 105.939 69.2188C105.939 44.6853 105.883 42.8659 104.891 41.1017C102.851 37.2976 98.2753 35.9193 94.4161 37.9041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.706 54.2782C119.336 55.8771 118.068 58.1375 118.068 60.9492C118.123 64.3122 119.005 65.6354 123.415 69.2741C130.307 74.8423 135.544 82.9467 137.75 91.2716C139.018 96.1783 139.018 106.267 137.695 111.119C135.434 119.664 129.48 128.651 122.864 133.558C114.374 139.843 106.435 142.268 95.8497 141.882C88.021 141.552 83.5553 140.284 77.1049 136.424C72.3636 133.613 65.5824 126.997 62.9912 122.586C57.037 112.387 55.383 100.258 58.5807 89.8933C60.9513 82.1197 63.7079 77.7643 70.2686 71.3139C75.892 65.8008 76.3331 65.2494 76.5536 62.9339C77.2703 56.9246 72.0328 52.514 66.2991 54.2782C63.8733 54.995 56.3754 61.721 52.6816 66.5175C40.277 82.671 37.4653 105.44 45.6247 124.02C51.3033 136.976 63.322 148.774 76.2228 153.956C94.0303 161.123 112.94 159.359 128.984 148.994C136.757 143.977 143.704 136.314 148.17 127.989C158.314 108.969 157.101 87.1367 144.917 68.9433C142.16 64.8084 132.788 55.436 130.086 54.168C127.44 52.9 123.691 52.9551 121.706 54.2782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.157ddd295bc18d928d6af7eab882ecc8.svg";
export { ForwardRef as ReactComponent };